import React, { useRef, useEffect } from 'react';
import { Form } from '@ss/mtd-react';
import { Select } from '@block/plug';
import { useRootStore } from '@src/model';
import { observer } from 'mobx-react-lite';
import { getEnumByCategory } from '@service/resumeDetail';
import ModuleView from '../../ModuleView';

const FormItem = Form.Item;

// 仅校招
function SkillStandard(props) {
  const formRefs = useRef<any[]>([]);
  const { data } = props;
  const { campusResumeDetail, campusResumeFormRefStore } = useRootStore();

  const store = campusResumeDetail;
  const storeRef = campusResumeFormRefStore;

  useEffect(() => {
    storeRef.changeRef('resumeSkillListRef', formRefs.current);
  }, [data, data?.length]);

  const handleValueChange = (index: string, formItemKey: string, formItemValue: any) => {
    switch (formItemKey) {
      case 'skillName': {
        store.setResumeSkillList(index, 'skillName', formItemValue?.name ? formItemValue.name : '');
        store.setResumeSkillList(index, 'skillCode', formItemValue?.id ? formItemValue.id : '');
        break;
      }
      case 'skillLevelName': {
        store.setResumeSkillList(index, 'skillLevelName', formItemValue?.name ? formItemValue.name : '');
        store.setResumeSkillList(index, 'skillLevel', formItemValue?.id ? formItemValue.id : '');
        break;
      }
      default:
        store.setResumeSkillList(index, formItemKey, formItemValue);
    }
  };

  const handleFetchData = async (category: string) => {
    const res = await getEnumByCategory({ category });
    return res;
  };

  return (
    <div className="skill_standard_edit model_edit">
      <div className="model_title">技能水平</div>
      {data?.map((item, index) => (
        <div className="model_list" key={item.renderId}>
          <Form
            ref={(el) => {
              formRefs.current[index] = el;
            }}
            className="modal_form"
            defaultFieldsValue={item}
            onFieldValueChange={(formItemKey, formItemValue) => handleValueChange(index, formItemKey, formItemValue)}
          >
            <FormItem formItemKey="skillName" span="11" labelWidth={0} required message="请填写技能类型">
              <div className="label">
                技能类型<span className="icon">*</span>
              </div>
              <Select
                toFormItem
                size="large"
                placeholder="请选择"
                labelField="name"
                keyField="id"
                onFetchData={() => handleFetchData('skill')}
              />
            </FormItem>
            <FormItem formItemKey="skillLevelName" span="11" labelWidth={0} required message="请填写技能水平">
              <div className="label">
                技能水平<span className="icon">*</span>
              </div>
              <Select
                toFormItem
                size="large"
                placeholder="请选择"
                labelField="name"
                keyField="id"
                onFetchData={() => handleFetchData('skillLevel')}
              />
            </FormItem>
          </Form>
          <div className="delete-list">
            <div onClick={() => store.deleteResumeList('resumeSkillList', index)}>删除这段信息</div>
          </div>
        </div>
      ))}
      <div
        className="list_add"
        onClick={() => {
          store.addResumeList('resumeSkillList');
        }}
      >
        <div className="add_icon">
          <img src={require('@imgs/add.svg')} alt="" />
        </div>
        添加技能水平
      </div>
    </div>
  );
}

export default ModuleView(observer(SkillStandard), 'skillStandard');
